import request from '@/utils/http';
import streamHttp from '@/utils/streamHttp';
const apiCrmHost = 'api-lcrm';

// 客户列表-rzq
export const getCustomerPage = (data) => {
    return request({
        url: apiCrmHost + '/customer/info/page',
        method: 'post',
        data
    });
};
// 客户新增-下一步校验-rzq
export const getCustomerAddVerify = (data) => {
    return request({
        url: apiCrmHost + '/customer/info/save/verify',
        method: 'post',
        data
    });
};
// 客户新增-特权新增校验-rzq
export const customerPrivilegeVerify = (data) => {
    return request({
        url: apiCrmHost + '/customer/info/save/verify/privileged',
        method: 'post',
        data
    });
};
// 客户新增-特权新增保存-rzq
export const saveCustomerPrivilegeVerify = (data) => {
    return request({
        url: apiCrmHost + '/customer/info/save/privileged',
        method: 'post',
        data
    });
};
// 客户新增-客户新增-rzq
export const saveCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/info/save',
        method: 'post',
        data
    });
};
// 客户新增-客户系提示-rzq
export const getCustomerGroupTips = (data) => {
    return request({
        url: apiCrmHost + '/customer/group/name/tips',
        method: 'post',
        data
    });
};
// 客户-导出客户信息-控权-rzq
export const customerExport = (data) => {
    return request({
        url: apiCrmHost + '/customer/info/export/auth',
        method: 'post',
        data
    });
};
// 客户-客户详情-rzq
export const getCustomerByCode = (params) => {
    return request({
        url: apiCrmHost + '/customer/info/getByCode',
        method: 'get',
        params
    });
};
// 客户-获取风险信息，风险信息会调天眼查-tr
export const getRiskInfoWithTyc = (data) => {
    return request({
        url: apiCrmHost + '/customer/util/risk/level/infoWithTaxpayer',
        method: 'post',
        data
    });
};
// 客户-联想查询-yjl
export const getCustomerNameBySearch = (data) => {
    return request({
        url: apiCrmHost + '/customer/util/tyc/ent/pagesearch',
        method: 'post',
        data
    });
};
// 客户-天眼查返回数据-yjl
export const getTycBaseInfo = (data) => {
    return request({
        url: apiCrmHost + '/customer/util/tyc/baseInfo',
        method: 'post',
        data
    });
};
// 客户-获取风险等级-yjl
export const getCustomerRiskLevel = (params) => {
    return request({
        url: apiCrmHost + '/customer/util/risk/level/info',
        method: 'get',
        params
    });
};
// 客户-保存联系人-cyj
export const saveContactInfo = (data) => {
    return request({
        url: apiCrmHost + '/contact/saveContactInfo',
        method: 'post',
        data
    });
};
// 客户-根据客户编码查询联系人-cyj
export const queryContactInfoByCustomerCode = (data) => {
    return request({
        url: apiCrmHost + '/contact/queryContactInfoByCustomerCode',
        method: 'post',
        data
    });
};
// 客户-同步联系人-cyj
export const syncContactInfo = (data) => {
    return request({
        url: apiCrmHost + '/contact/sync',
        method: 'post',
        data
    });
};
// 客户-删除联系人-cyj
export const deleteContactInfo = (data) => {
    return request({
        url: apiCrmHost + '/contact/deleteContactInfo',
        method: 'post',
        data
    });
};
// 客户-新增提交审批-rzq
export const customerSubmitFlow = (params) => {
    return request({
        url: apiCrmHost + '/customer/flow/submit',
        method: 'get',
        params
    });
};
// 客户-客户详情获取审批流信息-rzq
export const getCustomerChangeFlowInfo = (params) => {
    return request({
        url: apiCrmHost + '/customer/change/detail/one',
        method: 'get',
        params
    });
};
// 客户详情-保存-
// export const saveCustomer = (data) => {
//     return request({
//         url: apiCrmHost + '/customer/account/confirm',
//         method: 'post',
//         data
//     });
// };
// // 客户详情-新建审批-
// export const sumitFlowCustomer = (data) => {
//     return request({
//         url: apiCrmHost + '/customer/account/confirm',
//         method: 'post',
//         data
//     });
// };
// 客户详情-信息变更-
export const infoChangeCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/confirm',
        method: 'post',
        data
    });
};
// 客户详情-状态变更-
export const statusChangeCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/confirm',
        method: 'post',
        data
    });
};
// 客户详情-生成供应商-cyj
export const insertSupCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/info/createSupplierByCustomerCode',
        method: 'post',
        data
    });
};
// 客户详情-新建虚拟客户-
export const insertVirCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/confirm',
        method: 'post',
        data
    });
};
// 客户详情-同步集团-rzq
export const asyncGroupCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/push/gcrm',
        method: 'post',
        data
    });
};
// 客户详情-同步法务-rzq
export const asyncLawCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/push/fw',
        method: 'post',
        data
    });
};
// 客户详情-更新工商信息-yjl
export const updateBussinessCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/util/tyc/baseInfo/update',
        method: 'post',
        data
    });
};
// 客户详情-获取风险等级-rzq
export const getRiskLevelCustomer = (data) => {
    return request({
        url: apiCrmHost + '/ ',
        method: 'post',
        data
    });
};
// 客户详情-运维解锁-cyj
export const opsUnlockCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/info/queryCustomerEnableField',
        method: 'post',
        data
    });
};

// 客户详情-流程列表-rzq
export const getFlowList = (data) => {
    return request({
        url: apiCrmHost + '/customer/change/detail/page',
        method: 'post',
        data
    });
};

// 客户详情-流程信息-rzq
export const queryFlowByCustomer = (params) => {
    return request({
        url: apiCrmHost + '/customer/change/query',
        method: 'get',
        params
    });
};
// 客户详情-省市区-wy
export const queryAddressPlace = (data) => {
    return request({
        url: apiCrmHost + '/internationPlace/pageSearch',
        method: 'post',
        data
    });
};
// 客户详情-虚拟客户申请列表-变更对比-rzq
export const getCustomerComparsionPage = (params) => {
    return request({
        url: apiCrmHost + '/customer/flow/diff/show',
        method: 'get',
        params
    });
};
// 客户详情-虚拟客户新增-rzq
export const saveVirtualInfo = (data) => {
    return request({
        url: apiCrmHost + '/customer/virtual/info/save',
        method: 'post',
        data
    });
};
// 客户详情-客户信息变更-保存-rzq
export const saveChangeCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/change/save',
        method: 'post',
        data
    });
};
// 客户详情-客户状态变更申请-保存-rzq
export const saveStatusCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/status/info/save',
        method: 'post',
        data
    });
};
// 客户详情-虚拟客户新增-提交申请-rzq
export const submitVirtualFlow = (params) => {
    return request({
        url: apiCrmHost + '/customer/virtual/flow/submit',
        method: 'get',
        params
    });
};
// 客户详情-客户信息变更-提交申请(虚拟客户+非虚拟客户)-rzq
export const submitChangeFlow = (params) => {
    return request({
        url: apiCrmHost + '/customer/change/flow/submit',
        method: 'get',
        params
    });
};
// 客户详情-客户状态变更-提交申请(虚拟客户+非虚拟客户)-rzq
export const submitStatusFlow = (params) => {
    return request({
        url: apiCrmHost + '/customer/status/flow/submit',
        method: 'get',
        params
    });
};
// 客户详情-新增虚拟客户按钮校验--rzq
export const checkVirtualInfo = (data) => {
    return request({
        url: apiCrmHost + '/customer/virtual/info/verify',
        method: 'post',
        data
    });
};
// 客户详情-客户信息变更按钮校验--rzq
export const checkChangeInfo = (data) => {
    return request({
        url: apiCrmHost + '/customer/change/verify',
        method: 'post',
        data
    });
};
// 客户详情-客户状态变更按钮校验--rzq
export const checkStatusInfo = (data) => {
    return request({
        url: apiCrmHost + '/customer/status/info/verify',
        method: 'post',
        data
    });
};
// 客户详情-变更日志列表--rzq
export const getCustomerHistotyList = (data) => {
    return request({
        url: apiCrmHost + '/customer/his/query',
        method: 'post',
        data
    });
};
// 客户详情-销售易重推--rzq
export const xsyPush = (data) => {
    return request({
        url: apiCrmHost + '/customer/push/neo',
        method: 'post',
        data
    });
};
// 客户变更单列表-删除--rzq
export const delCustomerChangeFlow = (params) => {
    return request({
        url: apiCrmHost + '/customer/change/flow/del',
        method: 'get',
        params
    });
};
// 客户管理=白名单校验-xush
export const verifyWhiteCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/whitelist/flow/save/verifyCustomers',
        method: 'post',
        data
    });
};
// 客户管理=白名单审批流查询-xush
export const getCustomerWhitelistFlow = (params) => {
    return request({
        url: apiCrmHost + '/customer/whitelist/flow/query',
        method: 'get',
        params
    });
};
// 客户管理=白名单审批流保存-xush
export const saveCustomerWhitelistFlow = (data) => {
    return request({
        url: apiCrmHost + '/customer/whitelist/flow/save',
        method: 'post',
        data
    });
};
/** ---------------------客户一页纸相关接口--------------------- */
// 分页查询客户一页纸-cyj
export const getCustomeOnePageList = (data) => {
    return request({
        url: apiCrmHost + '/customer/onePage/page',
        method: 'post',
        data
    });
};
// 根据一页纸ID查询客户一页纸详情-cyj
export const getCustomeOnePageDetail = (params) => {
    return request({
        url: apiCrmHost + '/customer/onePage/getById',
        method: 'get',
        params
    });
};
// 保存客户一页纸（新增或更新）-cyj
export const saveCustomeOnePage = (data) => {
    return request({
        url: apiCrmHost + '/customer/onePage/save',
        method: 'post',
        data
    });
};
// 根据客户系查询最新版本一页纸-wy
export const getCustomeOnePageLatestVersion = (params) => {
    return request({
        url: apiCrmHost + '/customer/onePage/getLatestVersion',
        method: 'get',
        params
    });
};
// AI查询客户一页纸信息-wyj
export const streamCustomeOnePage = (data, callback) => {
    return streamHttp({
        url: 'api-sse-onepaper',
        body: data,
        callback
    });
};
// AI查询客户一页纸信息-cyj
export const queryOnePageEnableEditRole = (data) => {
    return request({
        url: apiCrmHost + '/customer/onePage/queryOnePageEnableEditRole',
        method: 'post',
        data
    });
};
// 客户一页纸-客户收入明细-wy
export const getCustomeOnePageIncome = (data) => {
    return request({
        url: apiCrmHost + '/customer/onePage/getIncomeProfitByYear',
        method: 'post',
        data
    });
};
// 客户一页纸-客户全量商机规模对比-wy
export const getCustomeOnePageScaleComparison = (data) => {
    return request({
        url: apiCrmHost + '/customer/onePage/getCustomerScaleComparison',
        method: 'post',
        data
    });
};
// 批量删除客户一页纸-cjy
export const deleteBatchCustomeOnePage = (data) => {
    return request({
        url: apiCrmHost + '/customer/onePage/deleteBatch',
        method: 'post',
        data
    });
};
// 修改客户一页纸状态-wy
export const updateStatusCustomeOnePage = (data) => {
    return request({
        url: apiCrmHost + '/customer/onePage/updateStatus',
        method: 'post',
        data
    });
};
// 解析客户一页纸word文档-chl
export const analysisCustomeOnePage = (data) => {
    return request({
        url: apiCrmHost + '/customer/onePage/saveDoc',
        method: 'post',
        data
    });
};
// 客户详情- 业务实体-推送ERP记录-更新-rzq
export const pushAccountRecord = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/push/record/update',
        method: 'post',
        data
    });
};
// 客户详情- 业务实体-推送ERP记录-查询-rzq
export const getPushRecordPage = (data) => {
    return request({
        url: apiCrmHost + '/customer/account/push/record/query/page',
        method: 'post',
        data
    });
};
// 客户管理-客户列表-角色权限控权-ylx
export const getCustomerListReport = (data) => {
    return request({
        url: apiCrmHost + '/customer/info/view/get',
        method: 'post',
        data
    });
};
